  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


$('.home_banner').slick({
  infinite: true,
  arrows:false,
  dots:true,
  autoplay: true,
  adaptiveHeight: true,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.best_selling_slider').slick({dots: false,infinite: true,speed: 500,slidesToShow: 5,slidesToScroll: 1,
  responsive: [{
    breakpoint: 1199,
    settings: {slidesToShow: 4,slidesToScroll: 1,infinite: true,dots: false}
  },{
    breakpoint: 991,
    settings: {slidesToShow: 3,slidesToScroll: 1}
  },{
    breakpoint: 768,
    settings: {slidesToShow: 2,slidesToScroll: 1,dots: false}
  }, {
    breakpoint: 480,
    settings: {slidesToShow: 1,slidesToScroll: 1,infinite: true,dots: false}
  }]
});

  jQuery(document).ready(function() {	  
    setTimeout(function() { 
      jQuery(".home_banner .home_banner_text").show();
    },500);
    
    setTimeout(function() {
      jQuery('.waterproof_left').css({'height': jQuery('.waterproof_right').outerHeight()}); 
    },1500);

    jQuery(window).on('resize', function(){
      jQuery('.waterproof_left').css({'height': jQuery('.waterproof_right').outerHeight()}); 
    });
  });  

jQuery(".site-nav__title").click(function(){
  if(jQuery(this).hasClass("show")){
    jQuery(this).removeClass("show");jQuery(this).next().slideUp();
  }
  else
  {
    jQuery(".site-nav__title").removeClass("show");jQuery(".site-nav__title").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();
  }
});

jQuery(".accordion-head").click(function(){
  if(jQuery(this).hasClass("show")){
    jQuery(this).removeClass("show");jQuery(this).next().slideUp();
  }
  else
  {
    jQuery(".accordion-head").removeClass("show");jQuery(".accordion-head").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();
  }
});


  (function() {
  // Pre-select an item
  var preSelectedFaq = null;
  var pathArr = String(window.location.pathname).split('/');
  if(pathArr.length === 4) {
    preSelectedFaq = pathArr[3];
  }

  if(preSelectedFaq != null) {
    $('.accordion-item').each(function(index) {
      if($(this).data('handle') === preSelectedFaq) {
        $('.accordion-item').removeClass('active-on-load');
        $(this).addClass('active-on-load');
        return false;
      }
    });
  }

  // Build accordion (no need jquery UI or plugin for a few lines of code...)
  $(document).on('click', '.accordion-item .article-title', function(e) {
    var selectedItem = $(this).parent();
    var isActive = selectedItem.hasClass('active') ? true : false;

    $('.accordion-item').each(function(index) {
      $(this).removeClass('active');

      if($(this).attr('id') == selectedItem.attr('id')) {
        if(!isActive) {
          $(this).addClass('active');
        }
      }

      var c = $(this).find('.article-content');

      if($(this).hasClass('active')) {
        c.css('max-height', c[0].scrollHeight);
      } else {
        c.css('max-height', 0);
      }
    });
  });

  $('.accordion-item').each(function(index) {
    if($(this).hasClass('active-on-load')) {
      $(this).find('.article-title').click();
      return false;
    }
  });

  $(window).on('resize', function() {
    adjustAccordionHeight();
  });
})();

function adjustAccordionHeight() {
  $('.accordion-item.active').each(function(index) {
    var c = $(this).find('.article-content');
    c.css('max-height', c[0].scrollHeight);
  });
}